<template>
    <base-select
        v-model="innerValue"
        :options="optionsList"
        name="User Type"
        label="User Type"
        placeholder="Select User Type"
    ></base-select>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    name: "UserTypesDropdown",
    props: {
        value: String,
    },
    setup(props, { emit }) {
        const optionsList = [
            {
                value: "Employee",
                text: "Employee",
            },
            {
                value: "Corporate Admin",
                text: "Company Admin",
            },
        ];

        const innerValue = computed({
            get: () => props.value,
            set: (newValue) => emit("input", newValue),
        });

        return {
            optionsList,
            innerValue,
        };
    },
});
</script>
